import React from 'react';
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl';
import { FormLabel } from 'react-bootstrap';

import { ONLINE_CAR_DISCOUNT } from 'js/constants';

class SummaryListCarPerks extends React.Component {
  render() {
    return null;

    /* const { intl, projectConfig } = this.props;
    const messages = intl.messages;

    return (
      <div className="m-b-15">
        <FormLabel className="m-r-10">{messages.can_be_ordered_online}</FormLabel>
        <FormLabel className="m-r-10">
          <FormattedMessage id="count_years_warranty" values={{ count: 2 }} />
        </FormLabel>
        {ONLINE_CAR_DISCOUNT > 0 ? (
          <FormLabel className="m-r-10">
            <FormattedMessage
              id="amount_online_advantage"
              values={{
                amount: (
                  <FormattedNumber
                    value={ONLINE_CAR_DISCOUNT}
                    style="currency"
                    currency={projectConfig.data.currency}
                  />
                ),
              }}
            />
          </FormLabel>
        ) : null}
      </div>
    ); */
  }
}

export default injectIntl(SummaryListCarPerks);
